module.exports = __webpack_public_path__ + "img/Campaigns_W.29507cbd.png";